module.exports = __webpack_public_path__ + "img/icon_map_1_off_011.ecc119e1.png";